module.exports = __webpack_public_path__ + "static/media/DLF - Flat Logo Azul Escuro.d06d0bd2.svg";